module.exports = __webpack_public_path__ + "img/20190807163506523.bff4ae0c.png";